import RestApiService from './rest.api.service';
class UserAPIService extends RestApiService {
    constructor() {
        super();
        super.authorized = true;
        super.updateContextPath('auth');
    }
    async me() {
        const response = await this.get('me');
        return response;
    }
}
export const userAPIService = new UserAPIService();
